module.exports = __webpack_public_path__ + "img/top-cover.52ad8193.png";